export const rightSidebar = {
  bg: 'palette.surface.3',
  header: {
    subtitle: 'palette.tertiary.50',
    title: 'palette.tertiary.90',
  },
  shadow: 'palette.black:0.4',
};
